/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review1_SubInputs */

const es_landing_review1_sub = /** @type {(inputs: Landing_Review1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida en la Ría de Vigo`)
};

const gl_landing_review1_sub = /** @type {(inputs: Landing_Review1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída na Ría de Vigo`)
};

const en_landing_review1_sub = /** @type {(inputs: Landing_Review1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trip on the Ría de Vigo`)
};

/**
* | output |
* | --- |
* | "Trip on the Ría de Vigo" |
*
* @param {Landing_Review1_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review1_sub = /** @type {((inputs?: Landing_Review1_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review1_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review1_sub(inputs)
	if (locale === "en") return en_landing_review1_sub(inputs)
	return es_landing_review1_sub(inputs)
});